import React from "react";
import "./style.css";

const NotFound = () => {
  return (
    <div className=" d-flex justify-content-center  align-items-center mt-5 ">
      <h1> این صفحه موجود نیست</h1>
    </div>
  );
};

export default NotFound;
